/*@ngInject*/
const UICustomOnChangeDirective = function ($timeout) {

    let linkFunction = function ($scope, $elm) {

        function onChangeHandler(event) {
            // Use this timeout to force a digest cycle since we are handling events outside of angular
            $timeout(function () {
                if (!_.isNil(event.target.files[0])) {
                    $scope.uiCustomOnChange({file: event.target.files[0], event: event});
                    $(event.target).val(null);
                }
            }, 0);
        }

        $elm.bind('change', onChangeHandler);

        $scope.$on('$destroy', function () {
            $elm.unbind('change', onChangeHandler);
        });
    };

    return {
        restrict: 'A',
        link: linkFunction,
        scope: {
            uiCustomOnChange: '&'
        }
    };
};

angular.module('umCore')
    .directive('uiCustomOnChange', UICustomOnChangeDirective);
